module.exports = __webpack_public_path__ + "img/guoneng.743a2d73.png";